import useContext from '../hooks/useContext';
import { SiteContext } from '.';
import { useComponentLoader } from '../utils/componentLoader';
import { CellContext } from './Cell';

export default (id?: string, manualRender?: boolean) => {
  const { cells, loading: loadingData } = useContext(SiteContext);
  const componentName = cells?.[id as string]?.component || '';
  const data = cells?.[id as string]?.data || null;
  const { get, loading: loadingComponent } = useComponentLoader([componentName]);

  if (!id || !cells[id]) {
    return {
      loadingData,
    };
  }

  if (manualRender) {
    return {
      loadingData,
      props: data,
    };
  }

  const Component = get(componentName);

  return {
    Component,
    componentName,
    loadingComponent,
    loadingData,
    props: data,
  };
};

export const useCellData = <TData>() => {
  return useContext(CellContext) as TData;
};
